// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import DocumentTitle from 'react-document-title';
import _ from 'lodash';

import {
  getCohorts,
} from 'actions/cohorts';
import {
  getSimulations,
  getSimulationReport,
  toggleSimulationStatus,
  resetSimulationDashboard,
} from 'actions/app';
import CohortDashboard from './cohort/CohortDashboard';
import SimulationDashboardPage from './simulation/SimulationDashboardPage';

type Props = {
  // cohort dashboard
  cohorts: Array<any>,
  lastOffset: ?string,
  getCohorts: Function,
  // simulation dashboard
  simulationList: ?Array<any>,
  getSimulations: Function,
  simulationDetails: Object,
  getSimulationReport: Function,
  lastEvaluatedKey: Object,
  toggleSimulationStatus: Function,
  resetSimulationDashboard: Function,
};

export class CentralDashboardPage extends Component {

  constructor(props: Props) {
    super(props);
    this.state = {
      tabStatus: 1,
    };
  }

  switchTab = (tabIdx: number) => {
    this.setState({
      tabStatus: 1 << tabIdx, // eslint-disable-line no-bitwise
    });
  }

  isActive = (tabIdx: number) => (this.state.tabStatus & (1 << tabIdx)) !== 0 // eslint-disable-line no-bitwise

  render() {
    return (
      <DocumentTitle title="Marionette">
        <section className="section">
          <div className="container">
            <h1 className="title is-2">Dashboards</h1>
            <div className="tabs is-centered is-boxed is-medium">
              <ul>
                <li className={classnames({
                  'is-active': this.isActive(0),
                })}
                >
                  <a onClick={() => this.switchTab(0)}>
                    <span className="icon is-small"><i className="fa fa-group" aria-hidden="true" /></span>
                    <span>Cohorts</span>
                  </a>
                </li>
                <li className={classnames({
                  'is-active': this.isActive(1),
                })}
                >
                  <a onClick={() => this.switchTab(1)}>
                    <span className="icon is-small"><i className="fa fa-gears" aria-hidden="true" /></span>
                    <span>Simulations</span>
                  </a>
                </li>
              </ul>
            </div>
            <div>
              {this.isActive(0) &&
                <CohortDashboard
                  cohorts={this.props.cohorts}
                  getCohorts={this.props.getCohorts}
                  lastOffset={this.props.lastOffset}
                />
              }
              {this.isActive(1) &&
                <SimulationDashboardPage {...this.props} />
              }
            </div>
          </div>
        </section>
      </DocumentTitle>
    );
  }
}

function mapStateToProps(state) {
  const {
    cohorts,
    lastOffset,
  } = state.app.user;
  return {
    // cohort dashboard
    cohorts: _.flatMap(cohorts || {}, (cohort, cohortID) => ({
      ...cohort,
      cohortID,
    })),
    lastOffset,
    // simulation dashboard
    simulationList: state.app.simulationList || [],
    simulationDetails: state.app.simulationDetails || null,
    lastEvaluatedKey: state.app.lastEvaluatedKey || null,
  };
}

export default connect(
  mapStateToProps, {
    // cohort dashboard
    getCohorts,
    // simulation dashboard
    getSimulations,
    getSimulationReport,
    toggleSimulationStatus,
    resetSimulationDashboard,
  }
)(CentralDashboardPage);



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/CentralDashboardPage.jsx
 **/